import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";


export const UiModal = (props) => {

    // const [show, setShow] = useState(true);

    // const handleClose = () => setShow(false);
    // const handleShow = () => setShow(true);


    return (
        <>
            <Modal show={props.show} onHide={props.handleClose} className='sb-main-modal sb-sign-up-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
                {props.subTitle &&
                <h5 className="sb-auth-sub-heading">{props.subTitle}</h5>
                }
                <Modal.Body>
                    {props.children}
                </Modal.Body>

            </Modal>
        </>
    )
}